export function taskDate(value: string | number | Date, timeZone = "Asia/Shanghai"): string {
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone, year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(new Date(value)).map(p => [p.type, p.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
}
export function taskOverdue(due: string | null, today: string, timeZone = "Asia/Shanghai", now = Date.now()) {
  const localToday = today || taskDate(now, timeZone);
  return !!due && (due.length === 10 ? due < localToday : Date.parse(due) < now);
}

/** 卡片上的截止日标签：逾期 N 天 / 今天 / 明天 / 月/日；tone 给样式用 */
export function dueLabel(due: string | null, today: string, timeZone = "Asia/Shanghai"): { text: string; tone: "late" | "today" | "" } | null {
  if (!due) return null;
  const day = taskDate(due, timeZone);
  const diff = Math.round((Date.parse(`${day}T00:00:00Z`) - Date.parse(`${today}T00:00:00Z`)) / 86400000);
  if (diff < 0) return { text: `逾期 ${-diff} 天`, tone: "late" };
  if (diff === 0) return { text: "今天", tone: "today" };
  if (diff === 1) return { text: "明天", tone: "" };
  return { text: `${Number(day.slice(5, 7))}/${Number(day.slice(8, 10))}`, tone: "" };
}
